import ChargeHelper, { ChargeConstants } from 'features/Charge/chargeHelper';
import DropdownTableConfigColumn from 'general/components/DropdownTableConfigColumn';
import KTFormSearch from 'general/components/OtherKeenComponents/Forms/KTFormSearch';
import KTBSDropdown from 'general/components/OtherKeenComponents/KTBSDropdown';
import KTLabel, { KTLabelSize } from 'general/components/OtherKeenComponents/KTLabel';
import KTPagination, {
  KTPaginationColor,
} from 'general/components/OtherKeenComponents/KTPagination';
import KTTable from 'general/components/OtherKeenComponents/KTTable';
import tableStyle from 'general/components/OtherKeenComponents/KTTable/tableStyle';
import ButtonFilterDropdown from 'general/components/quybka/Buttons/ButtonFilterDropdown';
import AppColors from 'general/constants/AppColors';
import AppRoute from 'general/constants/AppRoute';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import useConfigTableColumn from 'hooks/useConfigTableColumn';
import useRouter from 'hooks/useRouter';
import useWindowSize from 'hooks/useWindowSize';
import _ from 'lodash';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import ChargeTransactionListFilterView from './components/ChargeTransactionListFilterView';
import ToastHelper from 'general/helpers/ToastHelper';
import * as ExcelJS from 'exceljs';
import { AppCustomDialogHelper } from 'general/components/AppDialogCustom';
import CustomDropdownMultiChoiceView from 'general/components/quybka/Others/CustomDropdownMultiChoiceView';
import ChargeTransactionHelper from 'features/ManageChargeTransaction/chargeTransactionHelper';

ChargeTransactionListView.propTypes = {};

const defaultColumnIds = [
  'TRANSACTION_CODE',
  'START_TIME',
  'END_TIME',
  'STATUS',
  'RESERVATION_TIME',
  'POINT',
  'CONNECTOR',
  'PLATE',
  'DRIVER',
  'PHONE',
  'VEHICLE_TYPE',
  'VEHICLE_MODEL',
  'ENERGY',
  'AMOUNT',
  'SOC_START',
  'SOC_END',
  'STATION',
];

function ChargeTransactionListView(props) {
  // MARK: ---- PROPERTIES ----
  const router = useRouter();
  const user = useSelector((state) => state.auth.user);
  const prefKey = useMemo(() => {
    const userId = user.userId;
    const pathName = router.pathname;
    const key = `${userId}_${pathName}`;
    return key;
  }, [user, router]);
  const [loading, setLoading] = useState(false);
  const [chargeTransactionList, setChargeTransactionList] = useState([]);
  const [total, setTotal] = useState(0);
  const [filter, setFilter] = useState(ChargeHelper.Filter.chargeTransactionList);
  const fullColumns = useMemo(() => {
    return [
      {
        id: 'TRANSACTION_CODE',
        name: UIHelper.buildTableColumn('Mã phiên sạc'),
        selector: (row) => row?.transactionCode,
        minWidth: '110px',
        style: tableStyle.columns.normal,
      },
      {
        id: 'START_TIME',
        name: UIHelper.buildTableColumn('Thời gian bắt đầu'),
        selector: (row) =>
          row?.startTime ? Utils.formatDateTimeToString(row?.startTime, 'DD/MM/YYYY - HH:mm') : '',
        minWidth: '160px',
        style: tableStyle.columns.normal,
      },
      {
        id: 'END_TIME',
        name: UIHelper.buildTableColumn('Thời gian kết thúc'),
        selector: (row) =>
          row?.endTime ? Utils.formatDateTimeToString(row?.endTime, 'DD/MM/YYYY - HH:mm') : '',
        minWidth: '160px',
        style: tableStyle.columns.normal,
      },
      {
        id: 'STATUS',
        name: UIHelper.buildTableColumn('Trạng thái'),
        selector: (row) => {
          return (
            <KTLabel
              text={ChargeHelper.Utils.getChargeTransactionStatusName(row?.status)}
              isInline={true}
              size={KTLabelSize.medium}
              additionalClassName={`label-light-${ChargeHelper.Utils.getChargeTransactionStatusColor(
                row?.status
              )}`}
              additionalDescription={row?.status === ChargeConstants.ChargeTransactionStatus.CANCELLED ? row?.reason : ''}
            />
          );
        },
        minWidth: '180px',
        style: tableStyle.columns.normal,
      },
      {
        id: 'RESERVATION_TIME',
        name: UIHelper.buildTableColumn('Thời gian đặt chỗ'),
        selector: (row) =>
          row?.reservationEndTime ? Utils.formatDateTimeToString(row?.createdAt, 'DD/MM/YYYY - HH:mm') : '',
        minWidth: '160px',
        style: tableStyle.columns.normal,
      },
      {
        id: 'POINT',
        name: UIHelper.buildTableColumn('Trụ sạc'),
        selector: (row) => (
          <span
            className="cursor-pointer hover-opacity-60"
            onClick={() => {
              Utils.openInNewTab(
                `${AppRoute.pointList}/${row?.chargeConnector?.pointId ?? ''}`
              );
            }}
          >
            {row?.chargeConnector?.chargePoint?.name}
          </span>
        ),
        minWidth: '140px',
        style: tableStyle.columns.link,
      },
      {
        id: 'CONNECTOR',
        name: UIHelper.buildTableColumn('Vòi sạc'),
        selector: (row) => row?.chargeConnector?.name,
        minWidth: '140px',
        style: tableStyle.columns.normal,
      },
      {
        id: 'PLATE',
        name: UIHelper.buildTableColumn('Biển số xe'),
        selector: (row) => (
          <span
            className={`${Utils.isValid(row?.vehicleId) && _.toNumber(row?.vehicleId) !== 0
              ? 'cursor-pointer hover-opacity-60'
              : ''
              }`}
            onClick={() => {
              if (Utils.isValid(row?.vehicleId) && _.toNumber(row?.vehicleId) !== 0) {
                Utils.openInNewTab(`${AppRoute.vehicleList}/${row?.vehicleId}`);
              }
            }}
          >
            {Utils.isValid(row?.vehicleId) && _.toNumber(row?.vehicleId) !== 0 ? (
              row?.plate
            ) : (
              <span style={{ color: '#72728B' }}>{row?.plate}</span>
            )}
          </span>
        ),
        minWidth: '140px',
        style: tableStyle.columns.link,
      },
      {
        id: 'DRIVER',
        name: UIHelper.buildTableColumn('Tên chủ xe'),
        selector: (row) => (
          <span
            className={`${Utils.isValid(row?.user?.userId) && _.toNumber(row?.user?.userId) !== 0
              ? 'cursor-pointer hover-opacity-60'
              : ''
              }`}
            onClick={() => {
              if (Utils.isValid(row?.user?.userId) && _.toNumber(row?.user?.userId) !== 0) {
                Utils.openInNewTab(`${AppRoute.customerList}/${row?.user?.userId}`);
              }
            }}
          >
            {Utils.isValid(row?.user?.userId) && _.toNumber(row?.user?.userId) !== 0 ? (
              row?.user?.fullname
            ) : (
              <span style={{ color: '#72728B' }}>Vãng lai</span>
            )}
          </span>
        ),
        minWidth: '180px',
        style: tableStyle.columns.link,
      },
      {
        id: 'PHONE',
        name: UIHelper.buildTableColumn('Số điện thoại'),
        selector: (row) => row?.user?.phone,
        minWidth: '140px',
        style: tableStyle.columns.normal,
      },
      {
        id: 'VEHICLE_TYPE',
        name: UIHelper.buildTableColumn('Loại phương tiện'),
        selector: (row) =>
          row?.vehicle?.vehicleType
            ? _.find(
              ChargeHelper.Data.vehicleTypeOptions,
              (item) => item.value === row?.vehicle?.vehicleType
            )?.name
            : '',
        minWidth: '130px',
        style: tableStyle.columns.normal,
      },
      {
        id: 'VEHICLE_MODEL',
        name: UIHelper.buildTableColumn('Dòng xe'),
        selector: (row) => <span className="">{row?.vehicle?.model?.name}</span>,
        minWidth: '180px',
        style: tableStyle.columns.normal,
      },
      {
        id: 'ENERGY',
        name: UIHelper.buildTableColumn('Lượng điện đã sạc', 'kWh'),
        selector: (row) =>
          Utils.isValid(row?.energy) ? Utils.formatNumber((_.toNumber(row?.energy) / 1000).toFixed(3)) : '',
        minWidth: '140px',
        right: true,
        style: tableStyle.columns.normal,
      },
      {
        id: 'AMOUNT',
        name: UIHelper.buildTableColumn('Số tiền sạc', 'VNĐ'),
        selector: (row) =>
          row?.status === ChargeConstants.ChargeTransactionStatus.FINISHED
            ? Utils.formatNumber(
              row?.totalCost
            )
            : Utils.formatNumber(row?.estimatedEnergyCost),
        minWidth: '120px',
        right: true,
        style: tableStyle.columns.normal,
      },
      {
        id: 'SOC_START',
        name: UIHelper.buildTableColumn('SOC bắt đầu', '%'),
        selector: (row) =>
          row?.startSoc != null && row?.startSoc !== '' ? `${row.startSoc}` : '',
        minWidth: '120px',
        right: true,
        style: tableStyle.columns.normal,
      },
      {
        id: 'SOC_END',
        name: UIHelper.buildTableColumn('SOC kết thúc', '%'),
        selector: (row) =>
          row?.endSoc != null && row?.endSoc !== '' ? `${row.endSoc}` : '',
        minWidth: '120px',
        right: true,
        style: tableStyle.columns.normal,
      },
      {
        id: 'STATION',
        name: UIHelper.buildTableColumn('Trạm sạc'),
        selector: (row) => (
          <span
            className="cursor-pointer hover-opacity-60"
            onClick={() => {
              Utils.openInNewTab(
                `${AppRoute.stationList}/${row?.chargeStation?.stationId ?? ''}`
              );
            }}
          >
            {row?.chargeStation?.name}
          </span>
        ),
        minWidth: '200px',
        style: tableStyle.columns.link,
      },
      {
        name: UIHelper.buildTableColumn('Thao tác'),
        width: '100px',
        center: true,
        style: {
          position: 'sticky',
          right: 0,
          backgroundColor: '#fff',
          borderLeft: '1px solid #ebedfe',
        },
        cell: (row) => {
          return UIHelper.buildMoreActionsButton(buildMoreActions(row), true);
        },
      },
    ];
  }, []);
  const [fullColumnIds, setFullColumnIds] = useState(
    fullColumns.filter(column => !column.omit).map(column => column.id).filter(Boolean) || []
  );
  const {
    columnIds,
    columns,
    onChangeCheckboxValue,
    resetDefaultTableColumn,
    onSelectAll,
    onUnSelectAll,
    fullColumnsSorted,
    fullColumnsIdSorted,
    saveChanges,
  } = useConfigTableColumn(prefKey, fullColumnIds, defaultColumnIds, fullColumns);
  useEffect(() => {
    setLoading(true);
    const params = _.pickBy(
      filter,
      (value) => value !== null && value !== undefined && value !== ''
    );
    ChargeHelper.API.ChargeTransaction.requestGetChargeTransactionList(params)
      .then((data) => {
        setChargeTransactionList(data?.chargeTransactions);
        setTotal(data?.total);
      })
      .finally(() => {
        setLoading(false);
      });;
  }, [filter]);
  const windowSize = useWindowSize();
  const [selectedChargeStation, setSelectedChargeStation] = useState([]);
  const dropdownStationEl = useMemo(() => {
    return (
      <CustomDropdownMultiChoiceView
        id="stationId"
        name="stationId"
        toggleElement={({ showError }) => (
          <button
            className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between ${showError ? 'border-invalid' : ''}`}
            type="button"
          >
            {selectedChargeStation?.length > 0 ? selectedChargeStation.map(item => item.name).join(', ') : 'Chọn trạm sạc'}
          </button>
        )}
        selectedValue={selectedChargeStation}
        dropdownMenuItems={[{ name: 'Trạm sạc', role: 'STATION' }]}
        getSubItems={async (item) => {
          try {
            return await ChargeHelper.API.requestGetChargeStationList(
              Utils.filterParams({
                page: item?.page || 0,
                limit: 10,
                q: item?.q || '',
              })
            ).then((data) => {
              return {
                values: data.chargeStations?.map((station) => ({
                  id: station?.stationId,
                  name: station?.name,
                  item: station,
                })),
                total: data.total,
              };
            });
          } catch (error) {
            console.error('Error fetching station list:', error);
            return { values: [], total: 0 };
          }
        }}
        dropdownMenuStyle={{ maxHeight: '30vh' }}
        dropdownMenuClassName="overflow-auto w-100"
        onChange={(value) => {
          setSelectedChargeStation(value);
        }}
        onSave={(value) => {
          ChargeHelper.Filter.chargeTransactionList = {
            ...ChargeHelper.Filter.chargeTransactionList,
            stationId: value?.length > 0 ? value.map(item => item.id).join(', ') : '',
            page: 0,
          };
          handleRefresh();
        }}
        enableCheckValid
        isDropdownForm={true}
        searchable={true}
        searchFormClassName="mx-3 my-1 search-form-border"
        defaultValue={{
          name: 'Trạm sạc',
          role: 'STATION',
        }}
        idCheckType='id'
      />
    );
  }, [selectedChargeStation]);
  useEffect(() => {
    const stationIdsStr = ChargeHelper.Filter.chargeTransactionList?.stationId;

    if (!stationIdsStr?.trim()) return;

    const arrStationIds = stationIdsStr
      .split(',')
      .map(id => id.trim())
      .filter(id => id !== '')
      .map(id => parseInt(id, 10))
      .filter(id => !isNaN(id));

    if (arrStationIds.length === 0) return;

    Promise.all(
      arrStationIds.map(stationId =>
        ChargeHelper.API.getChargeStationDetail(stationId)
          .then(data => ({
            id: data?.stationId,
            name: data?.name,
            item: data,
          }))
          .catch(error => {
            console.error(`Error fetching station ${stationId}:`, error);
            return null;
          })
      )
    ).then(results => {
      const validResults = results.filter(item => item !== null);
      setSelectedChargeStation(validResults);
    });
  }, []);

  // MARK: ---- METHODS ----
  const buildMoreActions = (row) => {
    const actions = [];
    // xem chi tiet
    actions.push({
      text: 'Xem chi tiết',
      iconElement: <i className="fa-regular fa-eye" style={{ fontSize: '1.1rem' }} />,
      click: () => {
        router.navigate(`${row?.transactionId}`);
      },
    });
    // xuất hóa đơn phiên sạc
    if (ChargeTransactionHelper.isFinished(row?.status) && !Utils.isValid(row?.invoiceDocument)) {
      actions.push({
        text: 'Xuất hóa đơn',
        iconElement: <i className="fa-regular fa-file-export" style={{ fontSize: '1.1rem' }} />,
        click: () => {
          handleCreateInvoice(row)
        },
      });
    }
    return actions;
  };

  const handleRefresh = () => {
    setFilter({ ...ChargeHelper.Filter.chargeTransactionList });
  };

  const handleCreateInvoice = async (row) => {
    const transactionId = row?.transactionId;
    if (!transactionId) return;

    if (Utils.isValid(row?.invoiceSerial) && !Utils.isValid(row?.invoiceDocument)) {
      ToastHelper.showError('Đã xuất hoá đơn nhưng chưa tạo được file PDF');
      return;
    }
    const res = await ChargeHelper.API.ChargeTransaction.requestCreateInvoiceChargeTransaction({
      transactionId,
    });

    if (res && _.isBoolean(res)) {
      ToastHelper.showSuccess('Xuất hóa đơn thành công');
      handleRefresh();
    } else {
      ToastHelper.showError('Xuất hóa đơn thất bại');
    }
  };

  // xuat file excel
  const handleExportExcel = async (exportData, params) => {
    let exportDataList = exportData;
    if (_.isEmpty(exportDataList)) {
      ToastHelper.showError('Không có dữ liệu để tải xuống');
      return;
    }

    const sheetFileName = 'Danh_sách_phiên_sạc_' + moment(params.from).format('DDMMYYYY') + '_' + moment(params.to).format('DDMMYYYY');
    const ext = '.xlsx';
    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet('Danh sách phiên sạc', {
      headerFooter: {
        firstHeader: sheetFileName
      }
    });

    sheet.mergeCells('A1:AM1');
    sheet.getCell('A1').value = `DANH SÁCH PHIÊN SẠC (NGÀY ${moment(params.from).format(
      'DD/MM/YYYY'
    )} - ${moment(params.to).format('DD/MM/YYYY')})`;
    sheet.getCell('A1').font = {
      name: 'Times New Roman',
      family: 4,
      size: 11,
      bold: true,
      color: { argb: 'FFFFFFFF' },
    };
    sheet.getCell('A1').alignment = { vertical: 'middle', horizontal: 'center' };
    sheet.getCell('A1').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: '29618E' },
      color: { argb: 'FFFFFF' },
    };
    sheet.getCell('A1').border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
    sheet.getRow(1).height = 25;

    const columns = [
      { key: 'stt', width: 7 },
      { key: 'transactionCode', width: 20 },
      { key: 'startTime', width: 18 },
      { key: 'endTime', width: 18 },
      { key: 'invoiceNo', width: 20 },
      { key: 'invoiceDate', width: 18 },
      { key: 'customerCode', width: 18 },
      { key: 'companyCode', width: 18 },
      { key: 'customerName', width: 22 },
      { key: 'plate', width: 18 },
      { key: 'vehicleType', width: 18 },
      { key: 'cccd', width: 18 },
      { key: 'companyName', width: 22 },
      { key: 'address', width: 25 },
      { key: 'taxCode', width: 18 },
      { key: 'fixedEnergy', width: 15 },
      { key: 'fixedPrice', width: 15 },
      { key: 'peakEnergy', width: 15 },
      { key: 'peakPrice', width: 15 },
      { key: 'normalEnergy', width: 15 },
      { key: 'normalPrice', width: 15 },
      { key: 'offPeakEnergy', width: 15 },
      { key: 'offPeakPrice', width: 15 },
      { key: 'totalEnergy', width: 15 },
      { key: 'overChargeFee', width: 15 },
      { key: 'reservationFee', width: 15 },
      { key: 'amount', width: 15 },
      { key: 'discount', width: 15 },
      { key: 'amountAfterDiscount', width: 15 },
      { key: 'amountBeforeTax', width: 15 },
      { key: 'percentVat', width: 15 },
      { key: 'vatAmount', width: 15 },
      { key: 'status', width: 15 },
      { key: 'point', width: 15 },
      { key: 'connector', width: 15 },
      { key: 'socStart', width: 15 },
      { key: 'socEnd', width: 15 },
      { key: 'stationName', width: 25 },
      { key: 'stationAddress', width: 25 },
      { key: 'discountRate', width: 10 },
    ];
    sheet.columns = columns;

    sheet.mergeCells('A2:A3');
    sheet.mergeCells('B2:B3');
    sheet.mergeCells('C2:C3');
    sheet.mergeCells('D2:D3');
    sheet.mergeCells('E2:E3');
    sheet.mergeCells('F2:F3');
    sheet.mergeCells('G2:G3');
    sheet.mergeCells('H2:H3');
    sheet.mergeCells('I2:I3');
    sheet.mergeCells('J2:J3');
    sheet.mergeCells('K2:K3');
    sheet.mergeCells('L2:L3');
    sheet.mergeCells('M2:M3');
    sheet.mergeCells('N2:N3');
    sheet.mergeCells('O2:O3');
    sheet.mergeCells('X2:X3');
    sheet.mergeCells('Y2:Y3');
    sheet.mergeCells('Z2:Z3');
    sheet.mergeCells('AA2:AA3');
    sheet.mergeCells('AB2:AB3');
    sheet.mergeCells('AC2:AC3');
    sheet.mergeCells('AD2:AD3');
    sheet.mergeCells('AE2:AE3');
    sheet.mergeCells('AF2:AF3');
    sheet.mergeCells('AG2:AG3');
    sheet.mergeCells('AH2:AH3');
    sheet.mergeCells('AI2:AI3');
    sheet.mergeCells('AJ2:AJ3');
    sheet.mergeCells('AK2:AK3');
    sheet.mergeCells('AL2:AL3');
    sheet.mergeCells('AM2:AM3');

    sheet.getRow(2).height = 20;
    sheet.getRow(2).font = {
      name: 'Times New Roman',
      family: 4,
      size: 11,
      bold: true,
    };
    sheet.getRow(2).alignment = {
      vertical: 'middle',
      horizontal: 'center',
      wrapText: true,
    };

    sheet.getCell('A2').value = 'STT';
    sheet.getCell('B2').value = 'Mã phiên sạc';
    sheet.getCell('C2').value = 'Thời gian bắt đầu';
    sheet.getCell('D2').value = 'Thời gian kết thúc';
    sheet.getCell('E2').value = 'Số hóa đơn';
    sheet.getCell('F2').value = 'Ngày hóa đơn';
    sheet.getCell('G2').value = 'Mã khách hàng hệ thống';
    sheet.getCell('H2').value = 'Mã khách hàng doanh nghiệp';
    sheet.getCell('I2').value = 'Tên khách hàng';
    sheet.getCell('J2').value = 'Biển số xe';
    sheet.getCell('K2').value = 'Loại phương tiện';
    sheet.getCell('L2').value = 'Số CCCD của KH';
    sheet.getCell('M2').value = 'Tên công ty';
    sheet.getCell('N2').value = 'Địa chỉ';
    sheet.getCell('O2').value = 'MST/Mã số định danh';
    sheet.getCell('X2').value = 'Tổng số điện sạc (kWh)';
    sheet.getCell('Y2').value = 'Phí sạc quá giờ';
    sheet.getCell('Z2').value = 'Phí đặt giữ chỗ';
    sheet.getCell('AA2').value = 'Thành tiền + VAT';
    sheet.getCell('AB2').value = 'Giảm giá/chiết khấu';
    sheet.getCell('AC2').value = 'Số tiền sau giảm giá';
    sheet.getCell('AD2').value = 'Giá chưa thuế GTGT';
    sheet.getCell('AE2').value = '% thuế GTGT';
    sheet.getCell('AF2').value = 'Tiền thuế GTGT';
    sheet.getCell('AG2').value = 'Trạng thái';
    sheet.getCell('AH2').value = 'Trụ sạc';
    sheet.getCell('AI2').value = 'Vòi sạc';
    sheet.getCell('AJ2').value = 'SOC bắt đầu (%)';
    sheet.getCell('AK2').value = 'SOC kết thúc (%)';
    sheet.getCell('AL2').value = 'Tên trạm sạc';
    sheet.getCell('AM2').value = 'Địa chỉ trạm sạc';

    sheet.getCell('P2').value = 'Sạc cố định';
    sheet.mergeCells('P2:Q2');
    sheet.getCell('P2').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
    sheet.getCell('R2').value = 'Sạc giờ cao điểm';
    sheet.mergeCells('R2:S2');
    sheet.getCell('R2').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
    sheet.getCell('T2').value = 'Sạc giờ bình thường';
    sheet.mergeCells('T2:U2');
    sheet.getCell('T2').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
    sheet.getCell('V2').value = 'Sạc giờ thấp điểm';
    sheet.mergeCells('V2:W2');
    sheet.getCell('V2').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };

    sheet.getRow(3).height = 30;
    sheet.getRow(3).font = {
      name: 'Times New Roman',
      family: 4,
      size: 11,
      bold: true,
    };
    sheet.getRow(3).alignment = {
      vertical: 'middle',
      horizontal: 'center',
      wrapText: true,
    };
    sheet.getCell('P3').value = 'Số điện sạc (kWh)';
    sheet.getCell('Q3').value = 'Đơn giá + VAT (VNĐ)';
    sheet.getCell('R3').value = 'Số điện sạc (kWh)';
    sheet.getCell('S3').value = 'Đơn giá + VAT (VNĐ)';
    sheet.getCell('T3').value = 'Số điện sạc (kWh)';
    sheet.getCell('U3').value = 'Đơn giá + VAT (VNĐ)';
    sheet.getCell('V3').value = 'Số điện sạc (kWh)';
    sheet.getCell('W3').value = 'Đơn giá + VAT (VNĐ)';

    ['A2:AM2', 'A3:AM3'].forEach((range) => {
      sheet.getRow(range.split(':')[0].slice(1)).eachCell({ includeEmpty: true }, (cell) => {
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        };
      });
    });

    let i = 1;
    exportDataList?.forEach((row) => {
      const dataRow = sheet.addRow({
        stt: i++,
        transactionCode: row?.transactionCode,
        startTime: row?.startTime
          ? Utils.formatDateTimeToString(row?.startTime, 'DD/MM/YYYY - HH:mm')
          : '',
        endTime: row?.endTime
          ? Utils.formatDateTimeToString(row?.endTime, 'DD/MM/YYYY - HH:mm')
          : '',
        invoiceNo: !!row?.invoiceSerial
          ? String(row?.invoiceSerial).padStart(8, '0')
          : '',
        invoiceDate: row?.endTime
          ? Utils.formatDateTimeToString(row?.endTime, 'DD/MM/YYYY')
          : '',
        customerCode: row?.user?.userCode,
        companyCode: row?.user?.companyCode,
        customerName: row?.user?.fullname,
        plate: row?.vehicle?.plate,
        vehicleType: row?.vehicle?.vehicleType
          ? _.find(
            ChargeHelper.Data.vehicleTypeOptions,
            (item) => item.value === row?.vehicle?.vehicleType
          )?.name
          : '',
        cccd: row?.user?.idCardNumber,
        companyName: row?.user?.vatName,
        address: row?.user?.vatAddress,
        taxCode: row?.user?.vatTaxCode,
        fixedEnergy:
          row?.actualPricing?.pricingMode === 'FLAT'
            ? _.toNumber(row?.energy) / 1000
            : null,
        fixedPrice:
          row?.actualPricing?.pricingMode === 'FLAT'
            ? row?.actualPricing?.flatPrice
            : null,
        peakEnergy:
          row?.actualPricing?.pricingMode === 'HOURS'
            ? _.toNumber(row?.peakHoursEnergy) / 1000
            : null,
        peakPrice:
          row?.actualPricing?.pricingMode === 'HOURS'
            ? row?.actualPricing?.peakPrice
            : null,
        normalEnergy:
          row?.actualPricing?.pricingMode === 'HOURS'
            ? _.toNumber(row?.normalHoursEnergy) / 1000
            : null,
        normalPrice:
          row?.actualPricing?.pricingMode === 'HOURS'
            ? row?.actualPricing?.normalPrice
            : null,
        offPeakEnergy:
          row?.actualPricing?.pricingMode === 'HOURS'
            ? _.toNumber(row?.offPeakHoursEnergy) / 1000
            : null,
        offPeakPrice:
          row?.actualPricing?.pricingMode === 'HOURS'
            ? row?.actualPricing?.offPeakPrice
            : null,
        totalEnergy: null,
        overChargeFee: row?.estimatedOverchargeCost ?? 0,
        reservationFee: 0,
        amount: null,
        discount: Math.round(
          row?.discountRate * row?.estimatedEnergyCost /
          (1 - row?.discountRate)
        ),
        amountAfterDiscount: null,
        amountBeforeTax: null,
        percentVat: 8,
        vatAmount: null,
        status: ChargeHelper.Utils.getChargeTransactionStatusName(row?.status),
        point: row?.chargeConnector?.chargePoint?.name,
        connector: row?.chargeConnector?.name,
        socStart:
          row?.startSoc != null && row?.startSoc !== '' ? row.startSoc : '',
        socEnd:
          row?.endSoc != null && row?.endSoc !== '' ? row.endSoc : '',
        stationName: row?.chargeStation?.name,
        stationAddress: row?.chargeStation?.address,
      });

      const rowIndex = dataRow.number;

      sheet.getCell(`X${rowIndex}`).value = {
        formula: `P${rowIndex}+R${rowIndex}+T${rowIndex}+V${rowIndex}`
      };
      sheet.getCell(`AA${rowIndex}`).value = {
        formula: `(P${rowIndex}*Q${rowIndex}+R${rowIndex}*S${rowIndex}+T${rowIndex}*U${rowIndex}+V${rowIndex}*W${rowIndex})+Y${rowIndex}+Z${rowIndex}`
      };
      sheet.getCell(`AC${rowIndex}`).value = {
        formula: `AA${rowIndex}-AB${rowIndex}`
      };
      sheet.getCell(`AD${rowIndex}`).value = {
        formula: `AC${rowIndex}/(1+AE${rowIndex}%)`
      };
      sheet.getCell(`AF${rowIndex}`).value = {
        formula: `AD${rowIndex}*(AE${rowIndex}/100)`
      };

      const energyCols = ['P', 'R', 'T', 'V', 'X'];
      const moneyCols = ['Q', 'S', 'U', 'W', 'Y', 'Z', 'AA', 'AB', 'AC', 'AD', 'AF'];

      energyCols.forEach(col => {
        sheet.getCell(`${col}${rowIndex}`).numFmt = '#,##0.###';
      });

      moneyCols.forEach(col => {
        sheet.getCell(`${col}${rowIndex}`).numFmt = '#,##0';
      });

      dataRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        };
        if (colNumber === 1) {
          cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
        } else if (colNumber >= 16 && colNumber <= 32 || colNumber >= 36 && colNumber <= 37) {
          cell.alignment = { vertical: 'middle', horizontal: 'right', wrapText: true };
        } else {
          cell.alignment = { vertical: 'middle', horizontal: 'left', wrapText: true };
        }
      });
    });

    sheet.eachRow((row, rowNumber) => {
      if (rowNumber >= 4) {
        row.font = {
          name: 'Times New Roman',
          family: 4,
          size: 11,
          bold: false,
        };
      }
    });

    workbook.xlsx.writeBuffer().then(function (data) {
      const blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = window.URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.download = sheetFileName + ext;
      anchor.click();
      window.URL.revokeObjectURL(url);
      ToastHelper.showSuccess('Tải xuống file Excel thành công');
      AppCustomDialogHelper.hide();
    });
  };

  return (
    <div>
      {UIHelper.buildCard(
        <div className="pb-4">
          {/* header */}
          <div className="px-4 pt-4 pb-4 d-flex align-items-center justify-content-between">
            <div className="d-flex flex-column">
              <span style={UIHelper.buildFontStyle('600', '18px', AppColors.gray[800])}>
                Danh sách phiên sạc
              </span>
              <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                Tổng:{' '}
                <span style={UIHelper.buildFontStyle('600', '14px', AppColors.primary)}>
                  {Utils.formatNumber(total)} phiên sạc
                </span>
              </span>
            </div>
            {/* actions */}
            <div className="d-flex align-items-center">
              {UIHelper.buildBlueButton(
                'Tải xuống',
                async () => {
                  try {
                    ChargeHelper.UI.Excel.showDialogDownloadExcelFile(
                      ChargeHelper.Filter.chargeTransactionList,
                      async (params) => {
                        try {
                          const { chargeTransactions = [] } = await ChargeHelper.API.ChargeTransaction.requestGetChargeTransactionList(params);
                          return handleExportExcel(chargeTransactions, params);
                        } catch (error) {
                          ToastHelper.showError(`Lỗi khi lấy dữ liệu: ${error.message}`);
                          return [];
                        }
                      },
                    );
                  } catch (error) {
                    ToastHelper.showError(`Lỗi khi khởi tạo tải xuống: ${error.message}`);
                  }
                },
                <i className="fa-regular fa-download" style={{ fontSize: 15 }} />
              )}
            </div>
          </div>

          {/* table */}
          <div className="">
            {/* filter */}
            <div className="row m-0 p-0 px-2">
              {/* tim kiem */}
              {windowSize.width >= 768 && (
                <div className="col mb-4 px-2">
                  {UIHelper.buildFormLabel('Tìm kiếm')}
                  <KTFormSearch
                    name="search"
                    placeholder="Theo mã phiên sạc, biển số xe, tên chủ xe, số điện thoại, dòng xe..."
                    value={filter.q}
                    onSubmit={(text) => {
                      ChargeHelper.Filter.chargeTransactionList = {
                        ...ChargeHelper.Filter.chargeTransactionList,
                        q: text,
                        page: 0,
                      };
                      handleRefresh();
                    }}
                  />
                </div>
              )}
              {/* loc theo trang thai */}
              {windowSize.width >= 1120 && (
                <div className="col mb-4 px-2">
                  {UIHelper.buildFormLabel('Trạng thái')}
                  <KTBSDropdown
                    name="status"
                    toggleElement={
                      <button
                        className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                        type="button"
                      >
                        {_.find(
                          ChargeHelper.Data.chargeTransactionStatusOptions,
                          (item) => item.value === ChargeHelper.Filter.chargeTransactionList?.status
                        )?.name ?? 'Tất cả'}
                      </button>
                    }
                    selectedValue={ChargeHelper.Filter.chargeTransactionList?.status}
                    dropdownMenuItems={[
                      { name: 'Tất cả', value: '' },
                      ...ChargeHelper.Data.chargeTransactionStatusOptions,
                    ]}
                    dropdownMenuClassName="overflow-auto w-100"
                    dropdownMenuStyle={{ maxHeight: '30vh' }}
                    onChange={(value) => {
                      ChargeHelper.Filter.chargeTransactionList = {
                        ...ChargeHelper.Filter.chargeTransactionList,
                        status: value,
                        page: 0,
                      };
                      handleRefresh();
                    }}
                    isDropdownForm={true}
                  />
                </div>
              )}
              {/* loc theo tram sac */}
              {windowSize.width >= 1368 && (
                <div className="col mb-4 px-2" style={{ maxWidth: 400 }}>
                  {UIHelper.buildFormLabel('Trạm sạc')}
                  {dropdownStationEl}
                </div>
              )}

              {/* loc theo loai phuong tien */}
              {windowSize.width >= 1630 && (
                <div className="col mb-4 px-2">
                  {UIHelper.buildFormLabel('Loại phương tiện')}
                  <KTBSDropdown
                    name="vehicleType"
                    toggleElement={
                      <button
                        className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                        type="button"
                      >
                        {_.find(
                          ChargeHelper.Data.vehicleTypeOptions,
                          (item) =>
                            item?.value === ChargeHelper.Filter.chargeTransactionList?.vehicleType
                        )?.name ?? 'Tất cả'}
                      </button>
                    }
                    selectedValue={ChargeHelper.Filter.chargeTransactionList?.vehicleType}
                    dropdownMenuItems={[{ name: 'Tất cả', value: '' }, ...ChargeHelper.Data.vehicleTypeOptions]}
                    dropdownMenuClassName="overflow-auto w-100"
                    dropdownMenuStyle={{ maxHeight: '30vh' }}
                    onChange={(value) => {
                      ChargeHelper.Filter.chargeTransactionList = {
                        ...ChargeHelper.Filter.chargeTransactionList,
                        vehicleType: value,
                        page: 0,
                      };
                      handleRefresh();
                    }}
                    isDropdownForm={true}
                  />
                </div>
              )}

              {/* thiet lap cot */}
              <div className="col mb-4 px-2 d-flex align-items-end gap-3">
                {/* bo loc */}
                <ButtonFilterDropdown
                  dropdownContent={
                    <ChargeTransactionListFilterView
                      initialSelectedChargeStation={selectedChargeStation}
                      onSelectedChargeStationChange={(value) => {
                        setSelectedChargeStation(value);
                      }}
                      onCancel={() => {
                        handleRefresh();
                      }}
                      onApply={() => {
                        handleRefresh();
                      }}
                    />
                  }
                />
                <DropdownTableConfigColumn
                  columnIds={columnIds}
                  fullColumns={fullColumns}
                  fullColumnIds={fullColumnsIdSorted}
                  onChangeCheckboxValue={onChangeCheckboxValue}
                  resetDefaultTableColumn={resetDefaultTableColumn}
                  onChangeFullColumnIds={(ids) => {
                    setFullColumnIds(ids);
                    const key = prefKey + '_FULL_COLUMN_IDS';
                    localStorage.setItem(key, ids.join('|'));
                  }}
                  onSelectAll={onSelectAll}
                  onUnSelectAll={onUnSelectAll}
                  saveChanges={saveChanges}
                />
              </div>
            </div>

            <div className="px-4">
              <KTTable
                columns={columns}
                items={chargeTransactionList}
                selectableRows={false}
                striped={false}
                compactGrid={false}
                onClickedRow={(row) => { }}
                onSelectedRowsChanged={(rows) => { }}
                onDoubleClickedRow={(row) => { }}
                noDataComponent={UIHelper.buildEmptyNoData(
                  'Vui lòng kiểm tra kết nối mạng hoặc tải lại trang.'
                )}
              />
            </div>
          </div>

          {/* pagination */}
          <div className="px-4 mt-2">
            <KTPagination
              currentPage={filter.page + 1}
              rowCount={total}
              rowsPerPage={filter.limit}
              currentItemInPageCount={chargeTransactionList?.length}
              onChangePage={(newPage) => {
                const iNewPage = parseInt(newPage);
                ChargeHelper.Filter.chargeTransactionList = {
                  ...ChargeHelper.Filter.chargeTransactionList,
                  page: iNewPage - 1,
                };
                handleRefresh();
              }}
              onChangeRowsPerPage={(newRowsPerPage) => {
                const iNewRowsPerPage = parseInt(newRowsPerPage);
                ChargeHelper.Filter.chargeTransactionList = {
                  ...ChargeHelper.Filter.chargeTransactionList,
                  limit: iNewRowsPerPage,
                  page: 0,
                };
                handleRefresh();
              }}
              loading={false}
              color={KTPaginationColor.success}
              appendText="phiên sạc"
            />
          </div>
        </div>,
        false
      )}
    </div>
  );
}

export default ChargeTransactionListView;
